//import {Entity, repository} from 'aurelia-orm';

//@repository(FileUpload)
//export class FileUpload extends Entity {
//    fileName: string;
//    progress: number = 0;
//    isComplete: boolean;
//    size: number;
//    lastModifiedDate: Date;
//}